import React from 'react';
import { QUICK_FILTER_SEARCH_OPTIONS_THRESHOLD } from '../../constants/constants';
import QuickFilterItem from './QuickFilterItem';
import type { FilterItemProps } from './QuickFilterItem';
import QuickFilterSearchMultiSelectItem from './QuickFilterSearchMultiSelectItem';

type QuickFilterAutoItemProps = FilterItemProps & {
    /** Allows automatic switching from default quick filter UI to search-based UI for large option sets. */
    allowAutoSwitchingQuickFilterType?: boolean;
};

export default function QuickFilterAutoItem({
    allowAutoSwitchingQuickFilterType = true,
    ...props
}: QuickFilterAutoItemProps) {
    if (allowAutoSwitchingQuickFilterType && props.filter.options.length > QUICK_FILTER_SEARCH_OPTIONS_THRESHOLD) {
        return <QuickFilterSearchMultiSelectItem {...props} />;
    }
    return <QuickFilterItem {...props} />;
}
